const DEFAULT_BRAND_KEY = "home-helper";

const BRAND_CONFIGS = {
  "home-helper": {
    brandKey: "home-helper",
    brandName: "Home-Helper",
    brandNamePlain: "Home Helper",
    brandNameUppercase: "HOME-HELPER",
    consumerByline: "Indoor Projects for Homeowners",
    consumerProjectsHeading: "Indoor Home Improvement Projects",
    brandSlug: "home-helper",
    consumerDomain: "home-helper.com",
    contractorDomain: "contractors.home-helper.com",
    shopDomain: "shop.home-helper.com",
    consumerBaseUrl: "https://home-helper.com",
    contractorBaseUrl: "https://contractors.home-helper.com",
    shopBaseUrl: "https://shop.home-helper.com",
    displayDomain: "home-helper.com",
    legalEntityName: "Home-Helper, LLC",
    copyrightName: "Home-Helper, LLC",
    logoAlt: "Home-Helper",
    assetNamespace: "home-helper",
  },
  "house-helper": {
    brandKey: "house-helper",
    brandName: "House-Helper",
    brandNamePlain: "House Helper",
    brandNameUppercase: "HOUSE-HELPER",
    consumerByline: "Outdoor Projects for Homeowners",
    consumerProjectsHeading: "Outdoor Home Improvement Projects",
    brandSlug: "house-helper",
    consumerDomain: "house-helper.com",
    contractorDomain: "contractors.house-helper.com",
    shopDomain: "shop.house-helper.com",
    consumerBaseUrl: "https://house-helper.com",
    contractorBaseUrl: "https://contractors.house-helper.com",
    shopBaseUrl: "https://shop.house-helper.com",
    displayDomain: "house-helper.com",
    legalEntityName: "Home-Helper, LLC",
    copyrightName: "Home-Helper, LLC",
    logoAlt: "House-Helper",
    assetNamespace: "house-helper",
  },
};

module.exports = {
  BRAND_CONFIGS,
  DEFAULT_BRAND_KEY,
};
